"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatComposer = ChatComposer;
var _react = require("react");
var _spinner = require("@design/ui/spinner");
var _materialSymbols = require("@design/icons/material-symbols");
var _addinChat = require("@design-generated/addin-chat");
var _addinChat2 = require("@design-generated/addin-chat.wiring");
var _chatComposer = require("@design-generated/chat-composer");
var _chatComposer2 = require("@design-generated/chat-composer.wiring");
var _webChat = require("@design-generated/web-chat");
var _webChat2 = require("@design-generated/web-chat.wiring");
var _attachment = require("@design/ui/attachment");
var _utils = require("@design/lib/utils");
var _button = require("@design/ui/button");
var _inputGroup = require("@design/ui/input-group");
var _truncatedTextWithCursorTooltip = require("../truncated-text-with-cursor-tooltip");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var VISIBLE_CONTEXT_ATTACHMENT_LIMIT = 3;
var EDITOR_TYPOGRAPHY_CLASS = "w-full overflow-y-auto px-4 pt-4 pb-2 text-base leading-5 text-foreground [&_.ProseMirror]:outline-none [&_.ProseMirror_p]:m-0 [&_.ProseMirror_p.is-editor-empty:first-child]:before:pointer-events-none [&_.ProseMirror_p.is-editor-empty:first-child]:before:float-left [&_.ProseMirror_p.is-editor-empty:first-child]:before:h-0 [&_.ProseMirror_p.is-editor-empty:first-child]:before:text-muted-foreground [&_.ProseMirror_p.is-editor-empty:first-child]:before:content-[attr(data-placeholder)]";
var PROMPT_BOX_SIZING_BY_SURFACE = {
  web: {
    heightClass: "max-h-50",
    isResizable: false
  },
  addin: {
    heightClass: "min-h-11 max-h-[60vh] resize-y",
    isResizable: true
  }
};
var CONTEXT_ATTACHMENT_PRESENTATIONS = {
  "past-chat": {
    icon: _materialSymbols.ChatIcon,
    testId: "chat-conversation-chip"
  },
  document: {
    icon: _materialSymbols.DescriptionIcon,
    testId: "chat-file-chip"
  }
};
function renderContextAttachmentMedia(attachment, Icon) {
  if (attachment.isLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_attachment.AttachmentMedia, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {})
    });
  }
  if (attachment.imagePreview) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_attachment.AttachmentMedia, {
      variant: "image",
      children: attachment.imagePreview
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_attachment.AttachmentMedia, {
    "data-sentry-element": "AttachmentMedia",
    "data-sentry-component": "renderContextAttachmentMedia",
    "data-sentry-source-file": "chat-composer.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
      "data-sentry-element": "Icon",
      "data-sentry-source-file": "chat-composer.tsx"
    })
  });
}
function renderContextAttachment(attachment) {
  var _CONTEXT_ATTACHMENT_P = CONTEXT_ATTACHMENT_PRESENTATIONS[attachment.kind],
    Icon = _CONTEXT_ATTACHMENT_P.icon,
    testId = _CONTEXT_ATTACHMENT_P.testId;
  var removeAction = attachment.onRemove ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_attachment.AttachmentActions, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_attachment.AttachmentAction, {
      "aria-label": "Remove ".concat(attachment.name),
      onClick: attachment.onRemove,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, {})
    })
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_attachment.Attachment, {
    "data-testid": testId,
    size: "xs",
    state: attachment.isLoading ? "uploading" : "done",
    className: "max-w-[240px] min-w-0",
    "data-sentry-element": "Attachment",
    "data-sentry-component": "renderContextAttachment",
    "data-sentry-source-file": "chat-composer.tsx",
    children: [renderContextAttachmentMedia(attachment, Icon), /*#__PURE__*/(0, _jsxRuntime.jsx)(_attachment.AttachmentContent, {
      "data-sentry-element": "AttachmentContent",
      "data-sentry-source-file": "chat-composer.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_attachment.AttachmentTitle, {
        title: attachment.name,
        "data-sentry-element": "AttachmentTitle",
        "data-sentry-source-file": "chat-composer.tsx",
        children: attachment.name
      })
    }), removeAction]
  }, "".concat(attachment.kind, "-").concat(attachment.id));
}
function renderWorkspaceTrigger(_ref) {
  var label = _ref.label,
    isDisabled = _ref.isDisabled,
    onOpen = _ref.onOpen;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_inputGroup.InputGroupButton, {
    size: "sm",
    "data-testid": "chat-composer-workspace",
    disabled: isDisabled,
    onClick: function onClick(event) {
      return onOpen(event.currentTarget);
    },
    className: "w-0 max-w-fit grow",
    "data-sentry-element": "InputGroupButton",
    "data-sentry-component": "renderWorkspaceTrigger",
    "data-sentry-source-file": "chat-composer.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_truncatedTextWithCursorTooltip.TruncatedTextWithCursorTooltip, {
      text: label !== null && label !== void 0 ? label : "Select Workspace",
      "data-sentry-element": "TruncatedTextWithCursorTooltip",
      "data-sentry-source-file": "chat-composer.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {
      "data-sentry-element": "KeyboardArrowDownIcon",
      "data-sentry-source-file": "chat-composer.tsx"
    })]
  });
}
function renderMagicPromptAction(surface, _ref2) {
  var state = _ref2.state,
    onImprove = _ref2.onImprove;
  var icon = state === "improving" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {
    "aria-hidden": "true"
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.SparklesIcon, {});
  if (surface === "addin") {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupButton, {
      size: "icon-sm",
      "data-testid": "chat-improve",
      disabled: state !== "ready",
      onClick: onImprove,
      "aria-label": "Magic Prompt",
      title: "Magic Prompt",
      children: icon
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_inputGroup.InputGroupButton, {
    size: "sm",
    "data-testid": "chat-improve",
    disabled: state !== "ready",
    onClick: onImprove,
    "data-sentry-element": "InputGroupButton",
    "data-sentry-component": "renderMagicPromptAction",
    "data-sentry-source-file": "chat-composer.tsx",
    children: [icon, "Magic Prompt"]
  });
}
function renderSendAction(sendState, onSend, onStop) {
  if (sendState === "loading") {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupButton, {
      size: "icon-sm",
      variant: "default",
      disabled: true,
      "aria-label": "Loading\u2026",
      title: "Loading\u2026",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {})
    });
  }
  if (sendState === "busy") {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupButton, {
      size: "icon-sm",
      variant: "default",
      onClick: onStop,
      "aria-label": "Interrupt",
      title: "Interrupt",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.StopFilledIcon, {})
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupButton, {
    size: "icon-sm",
    variant: "default",
    "data-testid": "chat-send",
    disabled: sendState === "empty",
    onClick: onSend,
    "aria-label": "Send",
    title: "Send",
    "data-sentry-element": "InputGroupButton",
    "data-sentry-component": "renderSendAction",
    "data-sentry-source-file": "chat-composer.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.SendIcon, {
      "data-sentry-element": "SendIcon",
      "data-sentry-source-file": "chat-composer.tsx"
    })
  });
}
function isEditorFocused(editorInstance) {
  return editorInstance !== null && !editorInstance.isDestroyed && editorInstance.view.hasFocus();
}
var EditorFocusAcrossScreenSwap = /*#__PURE__*/function (_Component) {
  function EditorFocusAcrossScreenSwap() {
    _classCallCheck(this, EditorFocusAcrossScreenSwap);
    return _callSuper(this, EditorFocusAcrossScreenSwap, arguments);
  }
  _inherits(EditorFocusAcrossScreenSwap, _Component);
  return _createClass(EditorFocusAcrossScreenSwap, [{
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(previousProps) {
      return previousProps.screenKind !== this.props.screenKind && isEditorFocused(this.props.editorInstance);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_previousProps, _previousState, wasEditorFocusedBeforeScreenSwap) {
      var editorInstance = this.props.editorInstance;
      if (!wasEditorFocusedBeforeScreenSwap || editorInstance === null || editorInstance.isDestroyed) return;
      editorInstance.view.focus();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
}(_react.Component);
function renderComposerScreen(surface, greeting, wiring) {
  if (greeting === null) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_chatComposer2.ChatComposerContext.Provider, {
      value: wiring,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_chatComposer.ChatComposerScreen, {})
    });
  }
  if (surface === "web") {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_webChat2.WebChatContext.Provider, {
      value: _objectSpread(_objectSpread({}, wiring), {}, {
        greetingGreeting: greeting
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_webChat.WebChatScreen, {})
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_addinChat2.AddinChatContext.Provider, {
    value: _objectSpread(_objectSpread({}, wiring), {}, {
      greetingGreeting: greeting
    }),
    "data-sentry-element": "AddinChatContext.Provider",
    "data-sentry-component": "renderComposerScreen",
    "data-sentry-source-file": "chat-composer.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_addinChat.AddinChatScreen, {
      "data-sentry-element": "AddinChatScreen",
      "data-sentry-source-file": "chat-composer.tsx"
    })
  });
}
function ChatComposer(_ref3) {
  var surface = _ref3.surface,
    greeting = _ref3.greeting,
    editor = _ref3.editor,
    editorInstance = _ref3.editorInstance,
    contextAttachments = _ref3.contextAttachments,
    addMenu = _ref3.addMenu,
    workspace = _ref3.workspace,
    secondaryActions = _ref3.secondaryActions,
    sendState = _ref3.sendState,
    onSend = _ref3.onSend,
    onStop = _ref3.onStop,
    magicPrompt = _ref3.magicPrompt,
    onVoiceInput = _ref3.onVoiceInput;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showsAllContextAttachments = _useState2[0],
    setShowsAllContextAttachments = _useState2[1];
  var promptBoxSizing = PROMPT_BOX_SIZING_BY_SURFACE[surface];
  function focusEditorFromEmptyPromptBoxArea(event) {
    var clickedOutsideTheText = event.target === event.currentTarget;
    if (!promptBoxSizing.isResizable || !clickedOutsideTheText || editorInstance === null || editorInstance.isDestroyed) return;
    editorInstance.commands.focus("end");
  }
  var overflowContextAttachmentCount = Math.max(0, contextAttachments.length - VISIBLE_CONTEXT_ATTACHMENT_LIMIT);
  var visibleContextAttachments = showsAllContextAttachments ? contextAttachments : contextAttachments.slice(0, VISIBLE_CONTEXT_ATTACHMENT_LIMIT);
  var contextAttachmentsToggleButton = overflowContextAttachmentCount > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
    variant: "link",
    size: "xs",
    className: "ml-auto",
    onClick: function onClick() {
      return setShowsAllContextAttachments(!showsAllContextAttachments);
    },
    children: showsAllContextAttachments ? "View less" : "\u2026".concat(overflowContextAttachmentCount, " more")
  }) : null;
  var contextAttachmentRow = contextAttachments.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_inputGroup.InputGroupAddon, {
    align: "block-start",
    className: "flex-wrap",
    children: [visibleContextAttachments.map(renderContextAttachment), contextAttachmentsToggleButton]
  }) : null;
  var workspaceTrigger = workspace ? renderWorkspaceTrigger(workspace) : null;
  var composerContent = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [contextAttachmentRow, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-slot": "input-group-control",
      className: (0, _utils.cn)(EDITOR_TYPOGRAPHY_CLASS, promptBoxSizing.heightClass),
      onClick: focusEditorFromEmptyPromptBoxArea,
      children: editor
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_inputGroup.InputGroupAddon, {
      align: "block-end",
      children: [addMenu, workspaceTrigger, secondaryActions, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "ml-auto"
      }), renderMagicPromptAction(surface, magicPrompt), onVoiceInput && /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupButton, {
        size: "icon-sm",
        onClick: onVoiceInput,
        "aria-label": "Voice input",
        title: "Voice input",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.MicIcon, {})
      }), renderSendAction(sendState, onSend, onStop)]
    })]
  });
  var wiring = {
    inputGroup: {},
    inputGroupContent: composerContent,
    inputGroupInput: {},
    inputGroupAddon: {}
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(EditorFocusAcrossScreenSwap, {
    screenKind: greeting === null ? "conversation" : "greeting",
    editorInstance: editorInstance,
    "data-sentry-element": "EditorFocusAcrossScreenSwap",
    "data-sentry-component": "ChatComposer",
    "data-sentry-source-file": "chat-composer.tsx",
    children: renderComposerScreen(surface, greeting, wiring)
  });
}